import StatementCard from './StatementCard';

export default StatementCard;
